"use client";

import { UserMenu } from "@/components/global/UserMenu";
import { usePathname } from "next/navigation";

//GlobalUserMenu - Client component that renders UserMenu on appropriate pages
//Excluded from checkout, auth, cred, and profile pages for cleaner UX

interface GlobalUserMenuProps {
  position?:
    | "top-right"
    | "top-left"
    | "bottom-right"
    | "bottom-left"
    | "inline";
  className?: string;
}

export function GlobalUserMenu({
  position = "top-right",
  className = "",
}: GlobalUserMenuProps) {
  const pathname = usePathname();

  // Don't show on checkout, auth, cred, or profile pages
  const excludedPaths = ["/checkout", "/auth", "/cred", "/profile"];
  const shouldHide = excludedPaths.some((path) => pathname?.startsWith(path));

  if (shouldHide) {
    return null;
  }

  return <UserMenu position={position} className={className} />;
}

export default GlobalUserMenu;
